import cx from "classnames";
import { Link } from "react-router-dom";

export enum LinkButtonType {
  primary = "primary",
  secondary = "secondary",
}

interface LinkButtonProps {
  children?: React.ReactNode;
  to: string;
  className?: string;
  style?: React.CSSProperties;
  disabled?: boolean;
  type?: LinkButtonType;
  target?: string;
}

const LinkButton = (props: LinkButtonProps) => {
  const { children, to, className, style, disabled, type, target } = props;

  const combinedClassName = cx(
    "link-button",
    {
      "link-button__primary": type === LinkButtonType.primary,
      "link-button__secondary": type === LinkButtonType.secondary,
      disabled: disabled,
    },
    className,
  );

  return (
    <Link to={to} className={combinedClassName} style={style} target={target}>
      {children}
    </Link>
  );
};

export default LinkButton;
